import Depth from '../../motion/Depth';

// Every page's hero. Depth layers: backdrop image (optional, drawn in the cast's ink style), glow, gridiron, content.
// Variant: 'gold' (default) | 'red' (drama) | 'flat'. `backdrop` = 'studio' | 'court' | null.
const BACKDROPS = {
  studio: '/images/film/studio_tape.webp',
  court: '/images/film/courtroom.webp',
};

export default function HeroBackground({ variant = 'gold', backdrop = null, children, className = '' }) {
  const bgClass = {
    gold: 'bg-gold-radial',
    red: 'bg-[radial-gradient(ellipse_70%_60%_at_30%_50%,rgba(220,38,38,0.15),transparent_60%)]',
    flat: '',
  }[variant];
  const src = BACKDROPS[backdrop];

  return (
    <Depth className={`relative overflow-hidden bg-gradient-to-b from-bg-base to-bg-surface ${className}`} strength={0.6}>
      {src && (
        <div className={`hero-backdrop ${variant === 'red' ? 'hero-backdrop--red' : ''}`} data-depth="-0.4" aria-hidden="true">
          <img src={src} alt="" />
        </div>
      )}
      <div className={`absolute inset-0 ${bgClass}`} data-depth="-0.8" aria-hidden="true" />
      <div className="absolute inset-0 bg-gridiron pointer-events-none" aria-hidden="true" />
      <div className="absolute inset-0 bg-noise opacity-[0.03] mix-blend-overlay pointer-events-none" aria-hidden="true" />
      <div className="relative">{children}</div>
    </Depth>
  );
}
